<mat-card class="download-logo-container">
    <mat-card-content>
        <p>{{ title }}</p>
    </mat-card-content>
    <mat-card-content class="logotipo-container" [ngClass]="{'logo-background': background === 'true'}">
        <img width="2000" height="555" src="{{urlImage}}" alt="Saldo">
    </mat-card-content>
    <mat-card-content>
        <a title="{{title}} PNG" mat-button href="{{urlDownloadImagesPng}}" download>
            <span class="material-icons-outlined">file_download</span>
            PNG
        </a>
        <a title="{{title}} SVG" mat-button href="{{urlDownloadImagesSvg}}" download>
            <span class="material-icons-outlined">file_download</span>
            SVG
        </a>
    </mat-card-content>
</mat-card>
